import React from "react";
import { USDollar } from "../../../utils/helpers";
import ServiceStatus from "../../serviceStatus";

const OrderDetailsSectionLatest = ({ service, lang, arPhrase, enPhrase }) => {
  const {
    id,
    serviceCategory,
    status,
    serviceStatusId,
    requesterEmail,
    requesterName,
    claimedValue,
    createdAt,
    requesterMobile,
    serviceTypeName,
  } = service;

  return (
    <div className="w-full">
      <div className="flex flex-col items-center justify-center">
        <div className="w-full bg-white flex flex-col md:flex-row flex-wrap gap-[16px] xl:gap-y-[32px] xl:gap-x-[10px] content-between ">
          <div className="flex flex-col content-between justify-between gap-1 min-w-[45%]">
            <p className="text-[14px] font-normal text-[#6F6A62]">
              {lang === "en"
                ? enPhrase["lblApplicationNumber"]
                : arPhrase["lblApplicationNumber"]}
            </p>
            <p className="text-sm font-bold text-[#010202]">{id}</p>
          </div>

          <div className="flex flex-col content-between justify-between gap-1 min-w-[45%]">
            <p className="text-[14px] font-normal text-[#6F6A62]">
              {lang === "en"
                ? enPhrase["lblApplicationTypeDot"]
                : arPhrase["lblApplicationTypeDot"]}
            </p>
            <p className="text-sm font-bold text-[#010202]">
              {serviceCategory}
            </p>
          </div>

          <div className="md:flex flex-col content-between  justify-start gap-1 min-w-[45%]">
            <p className="text-[14px] font-normal text-[#6F6A62]">
              {lang === "en" ? enPhrase["lblStatus"] : arPhrase["lblStatus"]}
            </p>
            <p className="flex gap-[4px] items-center text-sm font-bold text-[#010202]">
              <ServiceStatus serviceStatusId={serviceStatusId} />
              <span>{status}</span>
            </p>
          </div>

          <div className="flex flex-col content-between justify-between gap-1 min-w-[45%]">
            <p className="text-[14px] font-normal text-[#6F6A62]">
              {lang === "en"
                ? enPhrase["lblClassificationRequest"]
                : arPhrase["lblClassificationRequest"]}
            </p>
            <p className="text-sm font-bold text-[#010202]">
              {serviceTypeName}
            </p>
          </div>

          <div className="flex flex-col content-between justify-between gap-1 min-w-[45%]">
            <p className="text-[14px] font-normal text-[#6F6A62]">
              {lang === "en"
                ? enPhrase["lblApplicant"]
                : arPhrase["lblApplicant"]}
            </p>
            <p className="text-sm font-bold font-Almarai text-[#010202]">
              {requesterName}
            </p>
          </div>

          <div className="flex flex-col content-between justify-between gap-1 min-w-[45%]">
            <p className="text-[14px] font-normal text-[#6F6A62]">
              {lang === "en"
                ? enPhrase["lblApplicationDate"]
                : arPhrase["lblApplicationDate"]}
            </p>
            <p className="text-sm font-bold text-[#010202]">
              {new Date(createdAt).toLocaleDateString("en-GB")}
            </p>
          </div>

          <div className="flex flex-col content-between justify-between gap-1 min-w-[45%]">
            <p className="text-[14px] font-normal text-[#6F6A62]">
              {lang === "en" ? enPhrase["lblPhone"] : arPhrase["lblPhone"]}
            </p>
            <p
              className={`text-sm font-bold text-[#010202] ${
                lang === "en" ? "" : "text-right"
              } `}
              dir="ltr"
            >
              {requesterMobile}
            </p>
          </div>
          <div className="flex flex-col content-between justify-between gap-1 min-w-[45%]">
            <p className="text-[14px]  font-normal text-[#6F6A62]">
              {lang === "en" ? enPhrase["lblEmail"] : arPhrase["lblEmail"]}:
            </p>
            <p className="text-sm font-bold font-Almarai text-[#010202]">
              {requesterEmail}
            </p>
          </div>
          {/* <div className="flex flex-col  content-between justify-between gap-1 min-w-[45%]">
            <p className="text-[12px] font-normal text-[#010202]">
              {lang === "en"
                ? enPhrase["lblClaimAmount"]
                : arPhrase["lblClaimAmount"]}
              :
            </p>
            <p className="text-[16px] md:text-sm font-bold text-[#a98031] md:text-[#010202]">
              <span>{USDollar.format(claimedValue)} </span>
              <span>{lang === "en" ? "AED" : "درهم"}</span>
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsSectionLatest;
